<section class="flex flex-col w-full max-w-5xl mx-auto px-2 sm:px-3 gap-4 sm:gap-6 min-w-0 overflow-x-hidden">
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
    <div class="min-w-0">
      <h1 class="text-xl sm:text-2xl font-bold text-gray-800">Documents</h1>
      <p class="text-sm text-gray-600 mt-1">Fichiers déposés dans votre espace (stockage sécurisé).</p>
    </div>
    <label
      class="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-4 py-2.5 sm:py-2 bg-secondary text-white text-sm font-medium rounded-md cursor-pointer hover:bg-secondary-hover shrink-0"
      [class.opacity-60]="busy()"
      [class.pointer-events-none]="busy()"
    >
      <lucide-icon [name]="Upload" size="16"></lucide-icon>
      @if (uploading()) { Envoi... } @else { Charger un fichier }
      <input type="file" class="hidden" (change)="onFileSelected($event)" [disabled]="busy()" />
    </label>
  </div>

  <div class="bg-white rounded-md shadow-xl border border-gray-100 overflow-hidden min-h-[220px] min-w-0">
    @if (busy()) {
      <div class="flex flex-col items-center justify-center gap-3 py-16 px-4">
        <span class="material-symbols-outlined text-secondary text-5xl animate-spin">progress_activity</span>
        <p class="text-sm text-gray-600 text-center">{{ busyMessage() }}</p>
      </div>
    } @else if (files().length === 0) {
      <div class="px-4 py-10 text-center text-sm text-gray-500">Aucun fichier pour cette entreprise.</div>
    } @else {
      <!-- Mobile: cards -->
      <ul class="md:hidden divide-y divide-gray-100">
        @for (f of files(); track f.id) {
          <li class="p-4 flex flex-col gap-3">
            <div class="min-w-0">
              <p class="text-sm font-semibold text-gray-900 break-words">{{ f.originalFilename }}</p>
              <p class="text-xs text-gray-500 mt-1">
                {{ f.createdAt | date: 'dd/MM/yyyy HH:mm' }}
                <span class="mx-1.5 text-gray-300">·</span>
                {{ formatSize(f.sizeBytes) }}
              </p>
            </div>
            <div class="flex items-center gap-2">
              <button
                type="button"
                (click)="download(f)"
                class="inline-flex flex-1 items-center justify-center gap-1.5 rounded-md border border-gray-200 px-3 py-2 text-sm text-secondary hover:bg-secondary/10 cursor-pointer"
              >
                <lucide-icon [name]="Download" size="18"></lucide-icon>
                Télécharger
              </button>
              <button
                type="button"
                (click)="delete(f)"
                title="Supprimer"
                aria-label="Supprimer"
                class="inline-flex items-center justify-center rounded-md border border-red-100 p-2 text-red-600 hover:bg-red-50 cursor-pointer"
              >
                <lucide-icon [name]="Trash2" size="18"></lucide-icon>
              </button>
            </div>
          </li>
        }
      </ul>

      <!-- Desktop: table -->
      <div class="hidden md:block overflow-x-auto">
        <table class="w-full text-sm table-fixed">
          <thead>
            <tr class="bg-gray-50 text-left text-gray-600">
              <th class="px-4 py-3 font-medium w-[45%]">Nom</th>
              <th class="px-4 py-3 font-medium w-[25%]">Ajouté le</th>
              <th class="px-4 py-3 font-medium w-[15%]">Taille</th>
              <th class="px-4 py-3 font-medium text-right w-[15%]">Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (f of files(); track f.id) {
              <tr class="border-t border-gray-100 hover:bg-gray-50">
                <td class="px-4 py-3 text-gray-800 truncate" [title]="f.originalFilename">{{ f.originalFilename }}</td>
                <td class="px-4 py-3 text-gray-500 whitespace-nowrap">{{ f.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td class="px-4 py-3 text-gray-500 whitespace-nowrap">{{ formatSize(f.sizeBytes) }}</td>
                <td class="px-4 py-3 text-right">
                  <div class="inline-flex items-center gap-2">
                    <button
                      type="button"
                      (click)="download(f)"
                      title="Télécharger"
                      aria-label="Télécharger"
                      class="p-1.5 text-secondary hover:bg-secondary/10 rounded-md cursor-pointer"
                    >
                      <lucide-icon [name]="Download" size="22"></lucide-icon>
                    </button>
                    <button
                      type="button"
                      (click)="delete(f)"
                      title="Supprimer"
                      aria-label="Supprimer"
                      class="p-1.5 text-red-600 hover:bg-red-50 rounded-md cursor-pointer"
                    >
                      <lucide-icon [name]="Trash2" size="22"></lucide-icon>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</section>
